import { mapGetters, mapState } from 'vuex';

import styled, { css } from 'vue-styled-components';

import * as S from '@/components/header/Header.styled';

import { isValueExist } from '@util';

export default {
    name: 'TopToast',
    computed: {
        ...mapGetters('view', ['toastMessage', 'toastIsError']),
        ...mapState('view', ['toastStyle', 'toastPosition']),
        wrapper() {
            let { toastStyle } = this;

            toastStyle =
                toastStyle && isValueExist(toastStyle) ? toastStyle : css``;

            return styled(S.Toast)`
                ${toastStyle};
            `;
        },
    },
    render() {
        let {
            toastMessage,
            toastIsError,
            wrapper,
            toastPosition = 'below',
        } = this;

        if (!toastMessage) {
            return null;
        }

        const classes = ['top-toast-wrapper', toastPosition];

        return (
            <wrapper
                class={classes}
                isError={toastIsError}
                domPropsInnerHTML={toastMessage}
            ></wrapper>
        );
    },
};
